export default "__VITE_ASSET__DZZt6EjA__"